import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';

import { UtilitiesService } from '@services/utilities/1.0/utilities.service';
import { BASE_API_URL, PGAAS_API_URL, PUBLIC_PGAAS_API_URL } from './config';

@Injectable({
  providedIn: 'root',
})
export class BaseApiUrlInterceptor implements HttpInterceptor {
  XCorrelationId: string;

  constructor(
    @Inject(BASE_API_URL) private baseApiUrl: string,
    @Inject(PGAAS_API_URL) private pgaasApiUrl: string,
    @Inject(PUBLIC_PGAAS_API_URL) private publicPgaasApiUrl: string,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(UtilitiesService) private utils: any,
  ) {
    this.XCorrelationId = this.utils.generateGUID();
    if (isPlatformBrowser(this.platformId)) {
      this.baseApiUrl = this.getBaseApiUrl();
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldPrependBaseUrl =
      !/^(\.\/assets)/.test(req.url) &&
      !req.url.startsWith(this.baseApiUrl) &&
      !req.url.startsWith(this.pgaasApiUrl) &&
      !req.url.startsWith(this.publicPgaasApiUrl) &&
      !req.url.startsWith('https://');

    if (!shouldPrependBaseUrl) return next.handle(req);

    const isPgaas = req.params.has('pgaas');
    const isPublicPgaas = req.params.has('publicPgaas');
    const clonedReq = req.clone({
      params: isPgaas
        ? req.params.delete('pgaas')
        : isPublicPgaas
          ? req.params.delete('publicPgaas')
          : req.params,
      url:
        (isPublicPgaas ? this.publicPgaasApiUrl : isPgaas ? this.pgaasApiUrl : this.baseApiUrl) +
        req.url,
    });
    return next.handle(clonedReq);
  }

  private getBaseApiUrl(): string {
    const HREF: string = window.location.href;

    if (HREF.includes('www')) {
      return HREF.replace('www', 'api');
    }

    return this.baseApiUrl;
  }
}
